import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { HelpdeskView, canSeeHelpdesk, helpdeskSearchShape } from "../../components/helpdesk";
import { usePageBar } from "../../components/shell/page-bar";
import { useDefaultGamesId } from "../../lib/competition/games";

/**
 * `/accommodation/helpdesk` — her Helpdesk tab (PLAN §4), under S4's
 * Accommodation layout. Who: admins, a group with `helpdesk.handle` (the
 * host desk, a HOTEL) or `helpdesk.report` (a NOC: its own organisation's
 * tickets). A courtesy, not the control — the API decides every row in SQL.
 * `/incident-helpdesk` redirects here.
 */
export const Route = createFileRoute("/_app/accommodation/helpdesk")({
	validateSearch: z.object(helpdeskSearchShape),
	beforeLoad: ({ context }) => {
		if (!canSeeHelpdesk(context.session)) throw redirect({ to: "/accommodation" });
	},
	component: HelpdeskPage,
});

function HelpdeskPage() {
	const { t: tn } = useTranslation("nav");
	// A tab of Accommodation (hers): the bar names the module, not the P menu's "Incident Helpdesk" leaf.
	usePageBar({ title: tn("items.accommodation"), subtitle: tn("sections.logistics") });
	const { session } = Route.useRouteContext();
	const search = Route.useSearch();
	const navigate = Route.useNavigate();
	const gamesId = useDefaultGamesId(search.games_id);
	if (!gamesId)
		return (
			<div className="grid gap-[0.75rem]" aria-busy>
				<div className="skeleton h-[3rem] rounded-[0.625rem]" />
				<div className="skeleton h-[12rem] rounded-[0.625rem]" />
			</div>
		);
	return <HelpdeskView session={session} gamesId={gamesId} search={search} navigate={navigate} />;
}
